import * as React from 'react';
import AddAlertForm from '../Layout/Form/AddAlert';
import * as FleetModule from 'Modules/FleetModule';
import * as AlertModule from 'Modules/AlertModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as Dictionary from 'Models/Dictionary';
import { connect } from 'react-redux';

type P = {
    match: any;
    history: any;
};
type S = {
    //
};
type DispatchedP = {
    manageAlertCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => Function;
    showVehicleList: () => Function;
    getAlertById: (alertId: number) => Function;
    changeAlertListType: (type: ViewManagementModule.Types.AlertListTypeVisible) => Function;
    manageDomainOfIntrest: (type: 'ADD' | 'DELETE', domain: AlertModule.Types.DomainOfInterestDto) => Function;
    manageFleet: (type: 'ADD' | 'DELETE', fleet: FleetModule.Types.CarFleetSimpleDto) => Function;
    createAlert: (alert: AlertModule.Types.CreateAlertDefinitionRequest) => Function;
    updateAlert: (alertId: number, alertData: AlertModule.Types.CreateAlertDefinitionRequest) => Function;
    deleteAlert: (alertId: number) => Function;
};
type ConnectedP = {
    alertStore: AlertModule.Types.AlertStore;
};
class ManageAlert extends React.Component<P & ConnectedP & DispatchedP, S> {
    constructor(props: P & ConnectedP & DispatchedP) {
        super(props);
        this.handleAlertSubmit = this.handleAlertSubmit.bind(this);
    }
    private async handleAlertSubmit(formData) {
        const newAlertData: AlertModule.Types.CreateAlertDefinitionRequest = {
            alertCondition: formData.alertCondition.value,
            carIds: formData.carIds.map((e, i) => e.id),
            domainIds: formData.domainIds.map((e, i) => e.id),
            fleetIds: formData.fleetIds.map((e, i) => e.id),
            message: formData.message,
            name: formData.name,
            notifyByEmail: formData.notifyByEmail,
            notifyBySms: formData.notifyBySms,
            notifyBySystemNotification: formData.notifyBySystemNotification,
            priority: formData.priority
        };
        if (newAlertData.alertCondition === AlertModule.EnumTypes.AlertCondition.SPEEDING) {
            newAlertData.conditionValue = formData.conditionValue;
        } else {
            delete newAlertData.conditionValue;
        }
        if (this.props.match.params.alertId) {
            await this.props.updateAlert(this.props.match.params.alertId, newAlertData);
        } else {
            await this.props.createAlert(newAlertData);
        }
    }
    public async componentDidMount() {
        if (this.props.match.params.alertId) {
            await this.props.getAlertById(this.props.match.params.alertId);
        }
    }
    public render() {
        const { manageDomainOfIntrest, manageFleet, alertStore, match, changeAlertListType, manageAlertCars } = this.props;
        const alertConditionOptions = Dictionary.GenerateList(Dictionary.AlertConditionArray, 'carDetails');
        let initialValues = {};
        if (match.path === '/alerts/add') {
            initialValues = {
                domainIds: alertStore.manageDomainOfIntrest,
                fleetIds: alertStore.manageFleets,
                carIds: alertStore.manageCars,
                notifyByEmail: false,
                notifyBySystemNotification: false,
                notifyBySms: false,
                priority: AlertModule.EnumTypes.Priority.LOW
            };
        } else if (alertStore.activeAlert && match.params.alertId) {
            initialValues = {
                carIds: alertStore.manageCars,
                name: alertStore.activeAlert.name,
                fleetIds: alertStore.manageFleets,
                domainIds: alertStore.manageDomainOfIntrest,
                notifyByEmail: alertStore.activeAlert.notifyByEmail,
                notifyBySystemNotification: alertStore.activeAlert.notifyBySystemNotification,
                notifyBySms: alertStore.activeAlert.notifyBySms,
                priority: alertStore.activeAlert.priority,
                message: alertStore.activeAlert.message,
                conditionValue: alertStore.activeAlert.conditionValue,
                alertCondition: alertConditionOptions.find((e, i) => e.value === alertStore.activeAlert.alertCondition)
            };
        }

        return (
            <div className="main__content">
                <AddAlertForm
                    onSubmit={this.handleAlertSubmit}
                    initialValues={initialValues}
                    {...{
                        onCarDelete: car => manageAlertCars('DELETE', car),
                        onFleetDelete: fleet => manageFleet('DELETE', fleet),
                        onDomainDelete: domain => manageDomainOfIntrest('DELETE', domain),
                        showVehicleList: () => changeAlertListType('cars'),
                        showFleetList: () => changeAlertListType('fleets'),
                        showZonesList: () => changeAlertListType('zones')
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        alertStore: state.alertStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        showVehicleList: () => dispatch(ViewManagementModule.Actions.showVehicleList()),
        getAlertById: (alertId: number) => dispatch(AlertModule.Actions.getAlertById(alertId)),
        manageAlertCars: (type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto) => dispatch(AlertModule.Actions.manageCars(type, car)),
        manageDomainOfIntrest: (type: 'ADD' | 'DELETE', domain: AlertModule.Types.DomainOfInterestDto) => dispatch(AlertModule.Actions.manageDomainOfIntrest(type, domain)),
        manageFleet: (type: 'ADD' | 'DELETE', fleet: FleetModule.Types.CarFleetSimpleDto) => dispatch(AlertModule.Actions.manageFleet(type, fleet)),
        createAlert: (alertData: AlertModule.Types.CreateAlertDefinitionRequest) => dispatch(AlertModule.Actions.createAlert(alertData)),
        updateAlert: (alertId: number, alertData: AlertModule.Types.CreateAlertDefinitionRequest) => dispatch(AlertModule.Actions.updateAlert(alertId, alertData)),
        deleteAlert: (alertId: number) => dispatch(AlertModule.Actions.deleteAlert(alertId)),
        changeAlertListType: (type: ViewManagementModule.Types.AlertListTypeVisible) => dispatch(ViewManagementModule.Actions.changeAlertListType(type))
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(ManageAlert);



// WEBPACK FOOTER //
// ./src/components/Alerts/ManageAlert.tsx